import { observer } from 'mobx-react-lite'
import React, {useCallback} from 'react'
import {useDropzone} from 'react-dropzone'
import { Header, Icon } from 'semantic-ui-react';

interface Props {
    //setFiles: (files: File) => void;
    setFiles: (files: any) => void;
}

function PhotoWidgetDropzone(prpos: Props) {

    const dzStyles = {
        border: 'dashed 3px #eee',
        borderColor: '#eee',
        borderRadius: '5px',
        paddingTop: '30px',
        textAlign: 'center' as 'center',
        height: 200,
    }

    const dzActive = {
        borderColor: 'green'
    }

    const onDrop = useCallback((acceptedFiles: any) => {
        // Do something with the files
        console.log(acceptedFiles); //'

        let droppedFiles = acceptedFiles.map((file: any) => Object.assign(file, {
            preview: URL.createObjectURL(file)
        }));

        console.log(droppedFiles); //'

        prpos.setFiles(droppedFiles);
    //}, []);      
    }, [prpos.setFiles]);

    const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop});

    return (
        // <div {...getRootProps()}>
        <div {...getRootProps()} style={isDragActive ? {...dzStyles, ...dzActive} : dzStyles }>
            <input {...getInputProps()} />

            {/* {isDragActive ? <p>Drop the files here ...</p> : <p>Drag 'n' drop some files here, or click to select files</p> } */}
            <Icon name='upload' size='huge' />
            <Header content='Drop the files here!' />

        </div>
    )
}

export default observer(PhotoWidgetDropzone);